import React from 'react'
import { useLocation } from 'react-router-dom'

function TeamManagement({ size = 28 }) {
  const location = useLocation()
  const isActive = location.pathname.startsWith('/team-management')
  const color = isActive ? '#FFFFFF' : '#8F9DAC'

  return (
    <svg width={size} height={size} viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M24.2362 21C25.1104 21 25.8057 20.4499 26.43 19.6806C27.7081 18.106 25.6097 16.8476 24.8094 16.2314C23.9959 15.6049 23.0875 15.25 22.1665 15.1667M20.9999 12.8333C22.6107 12.8333 23.9165 11.5275 23.9165 9.91667C23.9165 8.30584 22.6107 7 20.9999 7'
        stroke={color}
        strokeWidth='1.8'
        strokeLinecap='round'
      />
      <path
        d='M3.76355 21C2.88936 21 2.19405 20.4499 1.56973 19.6806C0.291702 18.106 2.39005 16.8476 3.19035 16.2314C4.0039 15.6049 4.91228 15.25 5.83327 15.1667M6.4166 12.8333C4.80577 12.8333 3.49993 11.5275 3.49993 9.91667C3.49993 8.30584 4.80577 7 6.4166 7'
        stroke={color}
        strokeWidth='1.8'
        strokeLinecap='round'
      />
      <path
        d='M9.43097 17.6297C8.23889 18.3668 5.11335 19.8719 7.01702 21.7552C7.94695 22.6752 8.98264 23.3332 10.2848 23.3332H17.715C19.0171 23.3332 20.0528 22.6752 20.9827 21.7552C22.8864 19.8719 19.7609 18.3668 18.5688 17.6297C15.7733 15.9011 12.2263 15.9011 9.43097 17.6297Z'
        stroke={color}
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.0832 8.75008C18.0832 11.0052 16.2551 12.8334 13.9999 12.8334C11.7447 12.8334 9.91653 11.0052 9.91653 8.75008C9.91653 6.49491 11.7447 4.66675 13.9999 4.66675C16.2551 4.66675 18.0832 6.49491 18.0832 8.75008Z'
        stroke={color}
        strokeWidth='1.8'
      />
    </svg>
  )
}

export default TeamManagement
